// Weapon ids and display names (Warfork ids, 1–10).
// The id/name table is generated from the Rust core (`core/src/wire.rs`
// `weapon_schema()`); this module re-exports it and adds the UI-only icon keys.

import {
  GENERATED_WEAPON_IDS,
  GENERATED_WEAPON_NAMES,
} from "../net/weapons.generated";

export const WEAPON_NAMES = GENERATED_WEAPON_NAMES;
export const WEAPON_IDS = GENERATED_WEAPON_IDS;

/** Weapon id -> key used by `WEAPON_ICONS` in rules.ts. */
export const WEAPON_ICON_KEYS = [
  "",
  "melee",
  "machinegun",
  "shotgun",
  "grenade",
  "rocket",
  "plasma",
  "lightning",
  "railgun",
  "experimental",
  "ball",
] as const;

export function weaponName(id: number): string {
  return WEAPON_NAMES[id] ?? `Weapon ${id}`;
}
